import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  fieldAnswers: {},
  conditionsAccepted: false,
};

export const makePaymentAnonymousStepOneSlice = createSlice({
  name: 'makePaymentAnonymousStepOne',
  initialState,
  reducers: {
    resetStepOne: () => {
      return initialState;
    },
    setConditionsAccepted: (state, action) => {
      return { ...state, conditionsAccepted: action.payload };
    },
    setFieldAnswers: (state, action) => {
      return { ...state, fieldAnswers: action.payload };
    },
  },
});
export const { resetStepOne, setFieldAnswers, setConditionsAccepted } =
  makePaymentAnonymousStepOneSlice.actions;
export default makePaymentAnonymousStepOneSlice.reducer;
